import type {GuidedV2StrategyParams} from '../../GuidedV2StrategyService';
import {
  AbstractGuidedUiElement, GuidedUiFooterBanner,
  GuidedUiGenaiBanner,
  GuidedUiHistoryOfSearches,
  GuidedUiKeywordSuggestions,
  GuidedUiNoLinksSection, GuidedUiPopularQueries, type GuidedV2UiSection
} from '../../../guided2/models/ui';
import {GuidedUiQuickLinkSection} from '../../../guided2/subcomponents/ui-components';

const base = 'https://www.se.com/$CC/$LL/search/?q=$TERM';
const supportCenterUrl = 'https://www.se.com/$CC/$LL/work/support/';
const solutionsBannerUrl = 'https://www.se.com/$CC/$LL/work/solutions/';
const genAIBannerUrl = 'https://www.se.com/$CC/$LL/search';

const sections: Record<string, GuidedUiQuickLinkSection> = {
  products: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 6,
    name: 'Products',
    clickTarget: base + '&source=se/products',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'products',
      },
    ],
  }
  , productsTop: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 2,
    name: 'Products',
    clickTarget: base + '&source=se/products',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'products',
      },
    ],
  }
  ,
  documents: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 3,
    name: 'Documents',
    clickTarget: base + '&source=se/documents',
    importance: 'default',
    itemSources: [
      {searcher: 'se/guided', category: 'documents',}
    ],
  } as GuidedUiQuickLinkSection
  ,
  documentsAndSoftware: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 2,
    name: 'Documents & Software',

    clickTarget: base + '&source=se/documents',
    importance: 'default',
    itemSources: [
      {searcher: 'se/guided', category: 'documents-and-software',},
    ],
  } as GuidedUiQuickLinkSection
  ,
  solutions: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 6,
    name: 'Solutions',

    clickTarget: base + '&source=se/solutions',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'solutions',
      },
    ],
  } as GuidedUiQuickLinkSection
  ,
  solutionsTop: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 2,
    name: 'Solutions',

    clickTarget: base + '&source=se/solutions',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'solutions',
      },
    ],
  } as GuidedUiQuickLinkSection
  ,

  software: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 3,
    name: 'Software',
    clickTarget: base + '&source=se/software',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'software',
      },
    ],
  }
  ,
  support: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 3,
    name: 'Support',

    clickTarget: base + '&source=se/support',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'support',
      },
    ],
  },
  supportTop: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 2,
    name: 'Support',

    clickTarget: base + '&source=se/support',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'support',
      },
    ],
  }
  ,
  faqs: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 3,
    name: 'FAQs',

    clickTarget: base + '&source=restricted/faq',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'faq',
      },
    ],
  },
  faqsTop: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 2,
    name: 'FAQs',

    clickTarget: base + '&source=restricted/faq',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'faq',
      },
    ]
  }
  ,
  company: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 6,
    name: 'Company',
    clickTarget: base + '&source=se/company',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'company',
      },
    ],
  },
  companyTop: {
    showWhen: 'has-search-term',
    type: 'quick-links',
    slots: 2,
    name: 'Company',
    clickTarget: base + '&source=se/company',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'company',
      },
    ],
  }
  ,
  services: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 6,
    name: 'Services',

    clickTarget: base + '&source=se/services',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'services',
      },
    ],
  },
  servicesTop: {
    showWhen: 'always',
    type: 'quick-links',
    slots: 2,
    name: 'Services',

    clickTarget: base + '&source=se/services',
    importance: 'default',
    itemSources: [
      {
        searcher: 'se/guided',
        category: 'services',
      },
    ],
  }
};

const notQuickLinks: Record<string, AbstractGuidedUiElement> = {
  historyOfSearches: {
    itemSources: [{searcher: 'myschneider/history', category: 'se/all'}],
    resultSlots: 5,
    showWhen: 'no-search-term',
    type: 'history-of-searches',
  } as GuidedUiHistoryOfSearches
  ,
  searchSuggestions: {
    type: 'keyword-suggestions',
    label: 'Search suggestions',
    showWhen: 'has-search-term',
    maxItems: 10,
    itemSources: [
      {searcher: 'se/autosuggestion', category: 'popular-queries'},
    ]
  } as GuidedUiKeywordSuggestions,
  popularQueries: {
    showWhen: 'no-search-term',
    type: 'popular-queries',
    label: 'Popular queries',
    maxItems: 10,
    itemSources: [
      {searcher: 'se/autosuggestion', category: 'popular-queries'},
    ]
  } as GuidedUiPopularQueries,
};

const genAiBanner = {
  showWhen: 'always',
  type: 'genai-banner',
  buttonText: 'Try it out',
  text: 'Locate products faster than ever with our AI-powered search tool.',
  href: genAIBannerUrl,
} as GuidedUiGenaiBanner;

const defaultConfig: GuidedV2StrategyParams = {
  backendTimeoutMs: 5000,
  useBackdrop: true,
  debounceTimeMs: 50,
  badgeHighlightThreshold: 0.1,
  markupHighlightThreshold: 0.01,
  enableBackgroundScroll: false,
  quickLinkTemplateMapperType: 'default',
  schema: {
    minLength: 3,
    sections: [],
  }
};

const blocks: Record<string, GuidedV2UiSection> = {
  TopResults: {
    name: 'Top Results',
    showWhen: 'has-search-term',
    uiElements: [
      sections.popularQueries,
      sections.productsTop,
      sections.documentsAndSoftware,
      sections.faqsTop,
      sections.supportTop,
      sections.companyTop,
      sections.solutionsTop,
      sections.servicesTop,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        // clickTarget: 'https://www.se.com/au/en/search/?q=$TERM',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [
          {searcher: 'se/guided', category: 'solutions',},
          {searcher: 'se/guided', category: 'products',},
          {searcher: 'se/guided', category: 'faq',},
          {searcher: 'se/guided', category: 'company',},
          {searcher: 'se/guided', category: 'services',},
          {searcher: 'se/guided', category: 'support',},
          {searcher: 'se/guided', category: 'documents-and-software',},
        ],
      } as GuidedUiNoLinksSection,
      {showWhen: 'always', 'type': 'divider'},
      notQuickLinks.searchSuggestions,
    ]
  },
  TopResultsDesignFirm: {
    name: 'Top Results',
    showWhen: 'has-search-term',
    uiElements: [
      sections.popularQueries,
      sections.documentsAndSoftware,
      sections.solutionsTop,
      sections.productsTop,
      sections.faqsTop,
      sections.supportTop,
      sections.companyTop,
      sections.servicesTop,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources:[
          {searcher: 'se/guided', category: 'solutions',},
          {searcher: 'se/guided', category: 'products',},
          {searcher: 'se/guided', category: 'faq',},
          {searcher: 'se/guided', category: 'company',},
          {searcher: 'se/guided', category: 'services',},
          {searcher: 'se/guided', category: 'support',},
          {searcher: 'se/guided', category: 'documents-and-software',},
        ],
      } as GuidedUiNoLinksSection,
      {showWhen: 'always', 'type': 'divider'},
      notQuickLinks.searchSuggestions,
    ]
  },
  DocumentsAndSoftware: {
    name: 'Documents & Software',
    showWhen: 'has-search-term',
    uiElements: [
      sections.documents,
      sections.software,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        // clickTarget: 'https://www.se.com/au/en/search/?q=$TERM&source=se/documents',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [
          {searcher: 'se/guided', category: 'documents'},
          {searcher: 'se/guided', category: 'software'},
        ],
      } as GuidedUiNoLinksSection
    ]
  },
  solutions: {
    name: 'Solutions',
    showWhen: 'has-search-term',
    uiElements: [
      sections.solutions,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        // clickTarget: 'https://www.se.com/au/en/search/?q=$TERM&source=se/solutions',
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [{searcher: 'se/guided', category: 'solutions',}],
      } as GuidedUiNoLinksSection,
      {showWhen: 'has-search-term', 'type': 'divider'},
      {
        type: 'footer-banner',
        name: 'solutions-banner',
        showWhen: 'has-search-term',
        buttonText: 'Explore More',
        text: 'Solutions for your business - Connect to your integrated energy management solutions anytime, anywhere.',
        href: solutionsBannerUrl
      } as GuidedUiFooterBanner,
    ]
  },
  Products: {
    name: 'Products',
    showWhen: 'has-search-term',
    uiElements: [
      // sections.productsRanges,
      // sections.productsCategories,
      sections.products,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [{searcher: 'se/guided', category: 'products',}],
      } as AbstractGuidedUiElement,
      // {showWhen: 'always', 'type': 'divider'},
      //sections.footerBannerLocateFasterWithAi
    ]
  },
  ProductsWithGenAI: {
    name: 'Products',
    showWhen: 'has-search-term',
    uiElements: [
      sections.products,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [{searcher: 'se/guided', category: 'products',}],
      } as AbstractGuidedUiElement,
      genAiBanner
    ]
  },
  Support: {
    name: 'Support',
    showWhen: 'has-search-term',
    uiElements: [
      sections.faqs,
      sections.support,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [
          {searcher: 'se/guided', category: 'faq',},
          {searcher: 'se/guided', category: 'support',},
        ],
      } as GuidedUiNoLinksSection,
      {showWhen: 'always', 'type': 'divider'},
      {
        showWhen: 'has-search-term',
        type: 'footer-banner',
        name: 'support-banner',
        buttonText: 'Support Center',
        text: 'Explore our support tools to find the help you need, when you need it!',
        href: supportCenterUrl,
      } as GuidedUiFooterBanner,
    ]
  },
  Company: {
    name: 'Company',
    showWhen: 'has-search-term',
    uiElements: [
      sections.company,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [{searcher: 'se/guided', category: 'company',}],
      } as GuidedUiNoLinksSection,
    ]
  },
  Services: {
    name: 'Services',
    showWhen: 'has-search-term',
    uiElements: [
      sections.services,
      {
        type: 'no-links-message',
        showWhen: 'has-search-term-with-results-loaded',
        clickTarget: base,
        message: 'We couldn\'t find any quick suggestions.',
        messageName: 'no-quick-suggestions',
        itemSources: [{searcher: 'se/guided', category: 'services',}],
      } as GuidedUiNoLinksSection,
    ]
  },
  NoSearchTerm: {
    name: 'Guided Search (no search term)',
    showWhen: 'no-search-term',
    uiElements: [
      notQuickLinks.popularQueries,
      // sections.historyOfSearches,
      // {showWhen: 'no-search-term', 'type': 'divider'},
      //{...sections.footerBannerLocateFasterWithAi, showWhen: 'no-search-term',}
    ]
  }
  ,
};

export const predefinedConfigs: Record<string, GuidedV2StrategyParams> = {
  'default': defaultConfig,
  designFirm: {
    ...defaultConfig,
    schema: {
      minLength: 3,
      sections: [
        blocks.TopResultsDesignFirm,
        blocks.DocumentsAndSoftware,
        blocks.solutions,
        blocks.Products,
        blocks.Support,
        blocks.Company,
        blocks.Services,
      ]
    }
  },
  genAI: {
    ...defaultConfig,
    schema: {
      minLength: 3,
      sections: [
        blocks.TopResults,
        blocks.ProductsWithGenAI,
        blocks.DocumentsAndSoftware,
        blocks.Support,
        blocks.Company,
        blocks.solutions,
        blocks.Services,
      ]
    }
  },
  'global': {
    ...defaultConfig,
    schema: {
      minLength: 3,
      sections: [
        blocks.TopResults,
        blocks.Products,
        blocks.DocumentsAndSoftware,
        blocks.Support,
        blocks.Company,
        blocks.solutions,
        blocks.Services,
      ]
    }
  }
};
